export enum CustomHttpHeader {
  CsrfToken = 'x-csrf-token',
  ClientType = 'x-client-type',
}